import React, { useState, useEffect } from "react";
import { LayoutGrid, List, Folder } from "lucide-react";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import PdfThumbnail from "components/PdfThumbnail";

const Home = () => {
  const [view, setView] = useState("grid");
  const [projects, setProjects] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [loading, setLoading] = useState(true);
  const [showRescaleModal, setShowRescaleModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [manualScaleLeft, setManualScaleLeft] = useState("1");
  const [manualScaleRight, setManualScaleRight] = useState("100");
  
  const [showHeightModal, setShowHeightModal] = useState(false);
const [floorHeights, setFloorHeights] = useState([]);
const [heightLoading, setHeightLoading] = useState(false);
  const apiUrl = import.meta.env.VITE_API_URL;


  
  const fetchProjects = async () => {
    try {
      // ✅ get user role from cookie (via /me API)
     
    const meRes = await fetch(`${apiUrl}/api/auth/me`, {
      credentials: "include",
    });

    if (!meRes.ok) throw new Error("Unauthorized");

    const meData = await meRes.json();

    console.log("ME RESPONSE:", meData);

    setUserRole(meData.role?.toLowerCase() || "user");



      const res = await fetch(`${apiUrl}/api/projects`, {
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
        credentials: "include",
      });

      if (!res.ok) throw new Error("Failed to fetch projects");

      const data = await res.json();

      const mappedProjects = data.projects
        ? data.projects.map((proj) => ({
            _id: proj._id,
            drawing_name: proj.drawing_name,
            pdf_path: proj.s3_url || proj.pdf_path,  // ✅ FIX
            scale: proj.scale || null,
            created_by: proj.created_by || "Unknown",
            project_id: proj.project_id || proj._id,
          }))
        : data.map((proj) => ({
            _id: proj._id,
            drawing_name: proj.drawing_name,
            pdf_path: proj.s3_url || proj.pdf_path,  // ✅ FIX
            scale: proj.scale || null,
            created_by: proj.created_by || "Unknown",
            project_id: proj.project_id || proj._id,
          }));
           
      setProjects(mappedProjects);
    } catch (err) {
      console.error("Error fetching projects:", err);
    } finally {
      setLoading(false);
    }
  };


  const handleRescale = async () => {
  if (!manualScaleLeft || !manualScaleRight) {
    alert("Please enter both scale values");
    return;
  }

  const finalScale = `${manualScaleLeft}:${manualScaleRight}`;

  try {
    const res = await fetch(
      `${apiUrl}/api/projects/${selectedProject._id}/scale`,
      {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          scale: finalScale,
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.message || "Failed to rescale");
    }

    console.log("Rescale success:", data);

    // ✅ modal close
    setShowRescaleModal(false);

    // ✅ reset inputs
    setManualScaleLeft("1");
    setManualScaleRight("100");

    // ✅ refresh project list (new scale dikhega)
    fetchProjects();

  } catch (err) {
    console.error("Rescale failed:", err);
    alert(err.message);
  }
};


  useEffect(() => {
    fetchProjects();
  }, []);

  return (
    <div className="flex flex-col h-full text-white">
      
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center space-x-2 text-sm">
          <span className="text-gray-400">Home</span>
          <span className="text-gray-600">/</span>
          <span className="text-white font-medium">Projects</span>
        </div>

        <div className="flex items-center space-x-3">
          <select className="bg-[#1b263b] border border-[#2d3e56] text-sm rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all">
            <option>My projects</option>
            <option>Team projects</option>
            <option>Archived projects</option>
          </select>

          <div className="flex space-x-1 bg-[#1b263b] border border-[#2d3e56] rounded-xl p-1">
            <button
              onClick={() => setView("grid")}
              className={`p-2 rounded-lg transition-all duration-200 ${
                view === "grid"
                  ? "bg-blue-600/20 text-blue-400 border border-blue-500/30"
                  : "text-gray-400 hover:text-white"
              }`}
            >
              <LayoutGrid size={18} />
            </button>
            <button
              onClick={() => setView("list")}
              className={`p-2 rounded-lg transition-all duration-200 ${
                view === "list"
                  ? "bg-blue-600/20 text-blue-400 border border-blue-500/30"
                  : "text-gray-400 hover:text-white"
              }`}
            >
              <List size={18} />
            </button>
          </div>
        </div>
      </div>

  
      {loading ? (
        <div className="flex justify-center items-center py-20 text-gray-400">
          Loading projects...
        </div>
      ) : (



        // project changes start






        //      <div
        //   className={`mt-6 grid ${
        //     view === "grid"
        //       ? "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
        //       : "grid-cols-1 gap-4"
        //   }`}
        // >
        //   {projects.length === 0 ? (
        //     <div className="flex flex-col items-center justify-center col-span-full text-center py-20">
        //       <Folder size={48} className="text-blue-400 mb-4" />
        //       <h3 className="text-2xl font-bold mb-2">No projects found</h3>
        //       <p className="text-gray-400 mb-8">
        //         Get started by creating your first project or exploring templates
        //       </p>
        //     </div>
        //   ) : 
          
          
        //   (
        //     projects.map((project) => (
        //       <div key={project._id} className="relative">
        //         <Link
        //           to={`/project/${project._id}`}
        //           state={{
        //             name: project.drawing_name,
        //             fileUrl: project.pdf_path,
        //             scale: project.scale, 
        //             created_by: project.created_by,
        //           }}
        //         >
        //           <div className="p-6 rounded-2xl bg-[#1b263b] border border-[#2d3e56] hover:border-blue-500/50 hover:bg-[#2d3e56] transition-all duration-200">
        //             <div className="flex items-center justify-between mb-4">
        //               <h4 className="font-medium text-white truncate">
        //                 {project.drawing_name}
        //               </h4>
        //             </div>

        //             {project.scale && (
        //               <p className="text-xs text-blue-400 mb-2">
                       
        //               </p>
        //             )}

        //           {project.pdf_path ? (
        //             project.pdf_path.toLowerCase().endsWith(".pdf") ? (
        //              <PdfThumbnail file={project.pdf_path} />
        //             ) : (
        //               <img
        //                 src={`${apiUrl}${project.pdf_path}`}
        //                 alt={project.drawing_name}
        //                 className="w-full h-40 object-cover rounded-lg mb-4"
        //               />
        //             )
        //           ) : null}
        //           </div>
        //         </Link>
        //       </div>
        //     ))
        //   )}
        // </div>







        //project changes end



        <div
          className={`mt-6 grid ${
            view === "grid"
              ? "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
              : "grid-cols-1 gap-4"
          }`}
        >
          {projects.length === 0 ? (
            <div className="flex flex-col items-center justify-center col-span-full text-center py-20">
              <Folder size={48} className="text-blue-400 mb-4" />
              <h3 className="text-2xl font-bold mb-2">No projects found</h3>
              <p className="text-gray-400 mb-8">
                Get started by creating your first project or exploring templates
              </p>
            </div>
          ) : (
            projects.map((project) => (
              <div key={project._id} className="relative">
                <Link
                  to={`/project/${project._id}`}
                  state={{
                    name: project.drawing_name,
                    // fileUrl: `${apiUrl}${project.pdf_path}`,
                    fileUrl: project.pdf_path,
                    scale: project.scale, 
                    created_by: project.created_by,
                  }}
                >
                  <div className="p-6 rounded-2xl bg-[#1b263b] border border-[#2d3e56] hover:border-blue-500/50 hover:bg-[#2d3e56] transition-all duration-200">
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="font-medium text-white truncate">
                        {project.drawing_name}
                      </h4>
                    </div>

                    {project.scale && (
                      <p className="text-xs text-blue-400 mb-2">
                       
                      </p>
                    )}

                  {project.pdf_path ? (
                    project.pdf_path.toLowerCase().endsWith(".pdf") ? (
                     <PdfThumbnail file={project.pdf_path} />
                    ) : (
                      <img
                        src={`${apiUrl}${project.pdf_path}`}
                        alt={project.drawing_name}
                        className="w-full h-40 object-cover rounded-lg mb-4"
                      />
                    )
                  ) : null}
                  </div>
                </Link>
                <button
      onClick={async (e) => {
        e.preventDefault();
        // const token = localStorage.getItem("token");

        setSelectedProject(project);
        setShowHeightModal(true);
        setHeightLoading(true);

        try {
          const res = await fetch(
            `${apiUrl}/api/projects/${project.project_id}/heights`,
            {
              // headers: { Authorization: `Bearer ${token}` },
              credentials: "include",
            }
          );

          const data = await res.json();
          if (!res.ok) throw new Error(data.message);

          setFloorHeights(data.heights || []);
        } catch (err) {
          alert(err.message);
          setShowHeightModal(false);
        } finally {
          setHeightLoading(false);
        }
      }}
      className="absolute top-4 right-20 p-2 bg-[#0d1b2a] border border-[#2d3e56] rounded-lg hover:bg-blue-600/30"
      title="View Floor Heights"
    >
      👁️
    </button>
               <button
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedProject(project);

                      //  SPLIT SCALE HERE
                      if (project.scale && project.scale.includes(":")) {
                        const [left, right] = project.scale.split(":");
                        setManualScaleLeft(left);
                        setManualScaleRight(right);
                      } else {
                        setManualScaleLeft("1");
                        setManualScaleRight("100");
                      }

                      setShowRescaleModal(true);
                    }}
                    className="absolute top-4 right-4 px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-xs rounded-lg transition-colors"
                  >
                    Rescaling
                  </button>
              </div>
            ))
          )}
        </div>
      )}
      
      {showRescaleModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-[#1b263b] border border-[#2d3e56] rounded-2xl p-6 w-106">
            <h3 className="text-xl font-bold text-white mb-4">Rescale {selectedProject?.drawing_name}</h3>

          {selectedProject?.scale && (
            <div className="mb-4 p-3 rounded-xl bg-[#0d1b2a] border border-[#2d3e56]">
              <p className="text-xs text-gray-500 mt-1">
                Last Modified By:
                <span className="text-gray-300 font-medium ml-1">
                  {selectedProject.created_by}
                </span>
              </p>
            </div>
          )}



            
            <p className="text-gray-300 mb-4">
              {/* Project id: {selectedProject?._id} <br /> */}
              {/* Drawing: {selectedProject?.drawing_name} */}
            </p>
            <p className="text-sm text-gray-400 mb-4">
              Please enter drawing scale.
            </p>
            
            <div className="flex items-center gap-2 mb-6">
              <input
                type="text"
                placeholder="1"
                value={manualScaleLeft}
                onChange={(e) => setManualScaleLeft(e.target.value)}
                className="flex-1 px-4 py-3 bg-[#0d1b2a] border border-[#2d3e56] rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 text-white text-center"
              />

              <span className="text-white text-xl font-bold">:</span>

              <input
                type="text"
                placeholder="100"
                value={manualScaleRight}
                onChange={(e) => setManualScaleRight(e.target.value)}
                className="flex-1 px-4 py-3 bg-[#0d1b2a] border border-[#2d3e56] rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 text-white text-center"
              />
            </div>
            
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => {
                  setShowRescaleModal(false);
                  setManualScaleLeft("1");
                  setManualScaleRight("");
                }}
                className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition-colors"
              >
                Cancel
              </button>
              

              <button
                onClick={handleRescale}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
              >
                Rescale
              </button>
            </div>
          </div>
        </div>
      )}



      {showHeightModal && (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
    <div className="bg-[#1b263b] border border-[#2d3e56] rounded-2xl p-6 w-[520px]">
      <h3 className="text-xl font-bold text-white mb-4">
        Floor Heights – {selectedProject?.drawing_name}
      </h3>

      {heightLoading ? (
        <p className="text-gray-400">Loading heights...</p>
      ) : floorHeights.length === 0 ? (
        <p className="text-gray-400">No height data available</p>
      ) : (
        <table className="w-full text-sm">
          <thead className="text-gray-400 border-b border-[#2d3e56]">
            <tr>
              <th className="py-2 text-left">From</th>
              <th className="py-2 text-left">To</th>
              <th className="py-2 text-right">Height (m)</th>
            </tr>
          </thead>
          <tbody>
            {floorHeights.map((h, i) => (
              <tr key={i} className="border-b border-[#2d3e56]">
                <td className="py-2">{h.from_level}</td>
                <td className="py-2">{h.to_level}</td>
                <td className="py-2 text-right text-blue-400 font-semibold">
                  {h.height_meters}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div className="flex justify-end mt-4">
        <button
          onClick={() => setShowHeightModal(false)}
          className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default Home;
